<template>
  <div
    v-if="goodsSpecList.length > 1 && visible && (!defaultGoods.cartGoodsType || defaultGoods.cartGoodsType != 2)"
    class="popover"
  >
    <!-- 以上：商品有多规格且该商品非奖品（cartGoodsType：2），可显示切换规格弹框 -->
    <div class="spec-wrap">
      <span>{{TLang('规格','my')}}</span>
      <ul>
        <li
          v-for="specgoods in goodsSpecList"
          :key="specgoods.id"
          :class="[specgoods.goodsId === activeId && 'defaultItem', specgoods.gray && 'gray' ]"
          @click="checkspecItem(specgoods)"
        >
          {{ specgoods.specValue }}
        </li>
      </ul>
    </div>
    <div class="footer-btns">
      <div
        class="confirm"
        @click="confirm"
      >
        {{TLang('确定','my')}}
      </div>
      <div
        class="cancle"
        @click="onCancle"
      >
        {{TLang('取消','my')}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    goodsSpecList: Array,
    defaultGoods: Object,
    handleSkuChange: Function,
    onCancle: Function,
    visible: Boolean,
  },
  data() {
    return {
      activeId: this.defaultGoods.goodsId,
      chooseGoods: this.defaultGoods,
    };
  },
  methods: {
    checkspecItem(goods) {
      if(!goods.gray && goods.goodsId !== this.activeId){
        this.activeId = goods.goodsId;
        this.chooseGoods = goods;
      }
    },
    confirm() {
      // if(this.defaultGoods.goodsId !== this.activeId){
      this.handleSkuChange &&
          this.handleSkuChange(this.chooseGoods, this.defaultGoods);
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.popover {
  position: absolute;
  line-height: 32px;
  background: #fff;
  color: #333;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(229, 229, 229, 1);
  z-index: 999;
  // display: none;
  top: 100%;
  .spec-wrap {
    display: flex;
    padding: 20px 15px;
    white-space: nowrap;
    // min-width: 308px;
    // max-width: 438px;
    max-width: 340px;
    width: auto;
    max-height: 300px;
    ul {
      display: flex;
      margin-left: 10px;
      flex-wrap: wrap;
      max-height: 260px;
      overflow-y: scroll;
      // min-width: 328px;
      // width: auto;
      width: 290px;
      li {
        border: 1px solid rgba(204, 204, 204, 1);
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        padding: 0 10px;
        text-align: center;
        line-height: 32px;
        margin-right: 10px;
        margin-bottom: 10px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          border-color: #3d96e2;
        }
      }
      li.gray{
        color: #ccc;
        border: 1px dashed #ccc;
        &:hover{
          cursor: not-allowed;
        }
      }
      .defaultItem {
        border: 2px solid rgba(61, 150, 226, 1);
      }
    }
  }
  .footer-btns {
    display: flex;
    margin-left: 48px;
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    margin-right: 20px;
    .confirm {
      width: 80px;
      height: 30px;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
      border-radius: 4px;
      color: #fff;
    }
    .cancle {
      width: 80px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid rgba(229, 229, 229, 1);
      color: rgba(153, 153, 153, 1);
      margin-left: 15px;
    }
  }
}
</style>
